import React from "react";

import { textToColor } from "@calcom/lib/textToColor";

type Props = {
  fullName: string;
};

export const LiteralAvatar: React.FC<Props> = ({ fullName }) => {
  return (
    <div className="relative flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-xs font-bold text-white">
      <div
        className="absolute h-8 w-8 rounded-full"
        style={{ backgroundColor: textToColor(fullName), opacity: "0.4" }}
      />
      <span className="relative text-black">{fullName.trim()?.charAt(0)?.toLocaleUpperCase()}</span>
    </div>
  );
};
